import { useQuery } from "@tanstack/react-query";
import { Site } from "~/shared/types/site";
import { Empty } from "~/shared/types/utility";
import { api } from "./utils/api-base";

export const useCurrentSite = () => {
  return useQuery({
    queryKey: ['current-site'],
    queryFn: async () => {
      const response = await api.get<Site | Empty>('/sites/current');
      return response.data;
    },
    staleTime: 'static' // never refetch
  }
  );
};
